<script setup lang="ts">
import { useStudentScreen } from '../../useStudentScreen'
import type { Student2Context } from '@/types/student2'
defineProps<{ context: Student2Context }>()
defineEmits<{ (e: 'click:shop'): void }>()

const { isVerySmallMobile } = useStudentScreen()
</script>

<template>
  <div ref="card" class="student-mainpage-course-card">
    <p class="student-mainpage-course-card__course-name" v-text="context.course_part.title" />
    <v-link mode="primary" :href="`/student/choose_course/${context.student.id}`" class="text-nowrap">
      Другие курсы
    </v-link>

    <span class="flex-spacer" />

    <v-link v-if="isVerySmallMobile" mode="primary" class="text-nowrap" @click="$emit('click:shop')"> Магазин </v-link>
    <v-button v-else mode="primary filled" @click="$emit('click:shop')"> Магазин </v-button>
  </div>
</template>

<style lang="scss">
@use '~/styles/pages/student2/screen' as s2;

.student-mainpage-course-card {
  padding: 16px;
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  background: $lightenGray;

  @include s2.mobile {
    font-size: 14px;
    gap: 4px;
    line-height: 18px;
  }

  @include s2.very-small-mobile {
    font-size: 12px;
    gap: 4px;
    line-height: 14px;
  }

  &__course-name {
    font-weight: bold;
    text-transform: uppercase;
  }

  .v-button {
    flex: 1 0 24px;
    min-height: 24px;
    max-height: 32px;
  }
}
</style>
